class MhCollapsibleOptions extends HTMLElement {
  connectedCallback() {
    this.contentEl = this.querySelector('[data-mh-content]');
    this.toggleEl = this.querySelector('[data-mh-toggle]');
    if (!this.contentEl || !this.toggleEl) return;

    this.checkOverflow();

    if (!this._resizeObserver) {
      this._resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this._resizeObserver.observe(this.contentEl);
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-testid="cart-drawer-trigger"]');
      if (trigger) setTimeout(() => this.checkOverflow(), 250);
    });

    this.toggleEl.addEventListener('click', () => {
      const expanded = this.classList.toggle('is-expanded');
      this.toggleEl.textContent = expanded ? 'Hide personalization' : 'View personalization';
    });
  }

  checkOverflow() {
    if (this.classList.contains('is-expanded')) return;
    requestAnimationFrame(() => {
      const isOverflowing = this.contentEl.scrollHeight > this.contentEl.clientHeight + 2;
      this.toggleEl.hidden = !isOverflowing;
    });
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }
}

if (!customElements.get('mh-collapsible-options')) {
  customElements.define('mh-collapsible-options', MhCollapsibleOptions);
}